import BasicAuthService from 'src/api/basicAuth';

const state = {
  token: null,
  error: null,
};
const getters = {
  token: (state) => {
    return state.token;
  },
  error: (state) => {
    return state.error;
  },
};
const actions = {
  async login({ commit }, payload) {
    const response = await BasicAuthService.login(payload);
    if (!response.success) {
      commit('setError', response.message);
      throw new Error(response.message);
    }
    commit('setToken', response.data);
    return true;
  },
  async register({ commit }, payload) {
    const response = await BasicAuthService.register(payload);
    if (!response.success) {
      commit('setError', response.message);
      throw new Error(response.message);
    }
    return true;
  },
  async createPublicSession({ commit }) {
    const response = await BasicAuthService.createPublicSession();
    if (!response || !response.success) {
      commit('setError', response.message);
      throw new Error(response.message);
    }
    commit('setToken', response.data);
    return true;
  },
  async forgotPassword({ commit }, payload) {
    const response = await BasicAuthService.forgotPassword(payload);
    if (!response.success) {
      commit('setError', response.message);
      throw new Error(response.message);
    }
    return response;
  },
  async resetPassword({ commit }, payload) {
    const response = await BasicAuthService.resetPassword(
      payload.payload,
      payload.token
    );
    if (!response.success) {
      commit('setError', response.message);
      throw new Error(response.message);
    }
    return true;
  },
  logout({ commit }) {
    commit('setToken', { token: null });
    commit('setError', null);
    // Clear all storage except data retained for the session
    Object.keys(sessionStorage).forEach((key) => {
      if (!key.includes('session')) {
        sessionStorage.removeItem(key);
      }
    });
  },
};
const mutations = {
  setToken(state, payload) {
    sessionStorage.setItem('token', payload.token);
    state.token = payload.token;
  },
  setError(state, payload) {
    state.error = payload;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
